import {createConstants} from '../utils';

export default createConstants(
 'ACTIVE',
 'ALL',
 'ARCHIVED',
);

